import { isFiniteNumber, roundToTwoDecimalPlaces } from "../math/math";
import { parseDecimal } from "../UnitParser";

export function arePricesDifferent(stored: unknown, autoPrice: number | undefined): boolean {
  const current = parseDecimal(stored);
  if (!isFiniteNumber(current) || !isFiniteNumber(autoPrice)) return false;
  return roundToTwoDecimalPlaces(current) !== roundToTwoDecimalPlaces(autoPrice);
}
